module.exports = __webpack_public_path__ + "static/media/main-bg.fa332a69.jpg";